function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "_1493748070_weather_icons-02",
  "data-name": "1493748070_weather_icons-02",
  transform: "translate(-22 -28)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_110",
  "data-name": "Path 110",
  d: "M29.026,33.529l-1.5-1.5a1.059,1.059,0,1,0-1.5,1.5l1.5,1.5a1.059,1.059,0,1,0,1.5-1.5Zm6.739-1.294a1.059,1.059,0,0,0,1.059-1.059V29.059a1.059,1.059,0,0,0-2.118,0v2.118A1.059,1.059,0,0,0,35.765,32.235ZM25.176,40.706H23.059a1.059,1.059,0,0,0,0,2.118h2.118a1.059,1.059,0,1,0,0-2.118Zm23.294,0H46.353a1.059,1.059,0,1,0,0,2.118h2.118a1.059,1.059,0,0,0,0-2.118ZM45.5,32.031a1.059,1.059,0,0,0-1.5,0l-1.5,1.5a1.059,1.059,0,1,0,1.5,1.5l1.5-1.5A1.059,1.059,0,0,0,45.5,32.031Zm-9.733,2.321a7.4,7.4,0,0,0-6.412,11.119,1.057,1.057,0,0,0,.916.528H41.261a1.057,1.057,0,0,0,.916-.528,7.4,7.4,0,0,0-6.412-11.119Zm4.848,9.529h-9.7a5.294,5.294,0,1,1,9.7,0Z",
  fill: "#4e4e4e"
}));

var SvgSun = function SvgSun(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27.529,
    height: 18,
    viewBox: "0 0 27.529 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSun, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sun.3ae8e35d.svg";
export { ForwardRef as ReactComponent };